import React from "react";
import { ModernSelect } from "src/components/ModernSelect/ModernSelect";
import {
  ServiceRequestTag,
  useServiceRequestTags,
} from "src/utils/CommonDataFetchingUtils/useServiceRequestTags";

interface TagOption {
  value: string;
  label: string;
}

interface TagFilterProps {
  tags: TagOption[];
  setTags: (next: TagOption[]) => void;
}

export const TagFilter = ({ tags, setTags }: TagFilterProps) => {
  const { serviceRequestTags } = useServiceRequestTags();

  const tagOptions: TagOption[] = serviceRequestTags.map(
    (item: ServiceRequestTag) => ({
      value: item.id,
      label: item.name,
    })
  );

  return (
    <>
      <div className="filters-modal__label">{"Tags"}</div>
      <div className="filters-modal-modern-select">
        <ModernSelect
          menuPlacement="top"
          placeholder="Select Tags"
          closeMenuOnSelect={false}
          isClearable
          isMulti
          options={tagOptions}
          value={tags}
          onChange={(newValue: any) => setTags(newValue)}
        />
      </div>
    </>
  );
};
